// Motif structuré demandé pour IGNORER / LOST — feed la boucle
// d'apprentissage. Les 8 motifs sont figés côté backend (CLOSE_REASONS).
import { useState } from "react";
import { X } from "lucide-react";
import { CLOSE_REASON_LABELS } from "@/lib/altiora-leads-i18n";
import {
  NAVY, CHAMPAGNE, IVORY, PrimaryButton, GhostButton,
} from "@/components/altiora/PremiumUI";
import { humanStatus } from "@/lib/altiora-leads-i18n";

export default function CloseReasonModal({ toStatus, onConfirm, onCancel }) {
  const [reason, setReason] = useState("");
  const [comment, setComment] = useState("");

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4"
         data-testid="close-reason-modal">
      <div className="absolute inset-0 bg-black/40" onClick={onCancel} />
      <div className="relative w-full max-w-md rounded-xl shadow-2xl overflow-hidden"
           style={{ background: IVORY }}>
        <header className="px-6 py-4 flex items-center gap-3"
                style={{ background: NAVY, color: IVORY }}>
          <h3 className="font-serif text-[15px] flex-1">
            {toStatus === "LOST"
              ? "Consigner la raison de la perte"
              : `Passer en « ${humanStatus(toStatus)} »`}
          </h3>
          <button onClick={onCancel} data-testid="close-reason-cancel"
                  className="p-1 rounded hover:bg-white/10">
            <X className="h-4 w-4" />
          </button>
        </header>
        <div className="p-6 space-y-4">
          <p className="text-[12px]" style={{ color: "#64748B" }}>
            Chaque motif alimente la boucle d'apprentissage — cela
            n'affecte jamais les règles de compliance.
          </p>
          <div className="space-y-2" data-testid="close-reason-options">
            {Object.entries(CLOSE_REASON_LABELS).map(([k, label]) => (
              <label key={k}
                     className="flex items-center gap-2 text-[13px] cursor-pointer"
                     data-testid={`close-reason-opt-${k}`}
                     style={{ color: NAVY }}>
                <input type="radio" name="reason" value={k}
                       checked={reason === k}
                       onChange={() => setReason(k)} />
                {label}
              </label>
            ))}
          </div>
          <div>
            <label className="text-[11px] font-mono uppercase tracking-[0.22em]"
                   style={{ color: "#64748B" }}>
              Commentaire (optionnel)
            </label>
            <textarea
              data-testid="close-reason-comment"
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              rows={2}
              className="w-full mt-1 rounded-md p-2 text-[13px]"
              style={{ background: "white",
                       border: `1px solid ${CHAMPAGNE}55`,
                       color: NAVY }} />
          </div>
          <div className="flex gap-2 justify-end">
            <GhostButton onClick={onCancel} testid="close-reason-cancel-btn">
              Annuler
            </GhostButton>
            <PrimaryButton
              onClick={() => onConfirm({
                reason: reason || undefined,
                comment: comment || undefined,
              })}
              disabled={!reason}
              testid="close-reason-confirm">
              Confirmer
            </PrimaryButton>
          </div>
        </div>
      </div>
    </div>
  );
}
